import React, { useState, useMemo, useRef } from "react";
import "../styles/contactUs.css";
import EmailIcon from "@mui/icons-material/Email";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { saveContactUsDetails } from "../service/contactUsService";
import countryList from "react-select-country-list";
import ReCAPTCHA from "react-google-recaptcha";
import Select from "react-select";
import { BASE_URL } from "../api-config/config";
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { generateTokenHandler, recaptcha_site_key } from "../utils/json-web";

const ContactUs = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  // const [country, setCountry] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [enquiry, setEnquiry] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [designation, setDesignation] = useState("");
  const [typeOfContent, setTypeOfContent] = useState(null);
  const [success, setSuccess] = useState(false);
  const [failure, setFailure] = useState(false);
  const [countryName, setCountryName] = useState("");
  const [phoneFailure, setPhoneFailure] = useState(false);
  // const [selCountryExpectedLength, setSelCountryExpectedLength] = useState(0)
  // const [contactNumber, setContactNumber] = useState("");
  const countryOptions = useMemo(() => countryList().getData(), []);
  const recaptchaRef = useRef(null);
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [message, setMessage] = useState(false);
  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);
  const options = [
    { value: "tvChannel", label: "TV Channel" },
    { value: "tvShow", label: "TV Show" },
    { value: "movie", label: "Movie" },
    { value: "standupComedyshow", label: "Stand Up Comedy Show" },
    { value: "documentry", label: "Documentary" },
    { value: "standalone", label: "Independent / Standalone Work" },
    { value: "trainingAndEducation", label: "Training And Education" },
    { value: "other", label: "Other" },
  ];
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #fff",
    boxShadow: 24,
    p: 2,
    textAlign: "center",
    borderRadius: 2,
  };

  const changeHandlerCountry = (value) => {
    setCountryName(value);
  };

  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value);
    //console.log(firstName);
  };

  const handleLastNameChange = (e) => {
    setLastName(e.target.value);
  };

  const handleOrganizationChange = (e) => {
    setOrganizationName(e.target.value);
  };

  const handleDesignationChange = (e) => {
    setDesignation(e.target.value);
  };

  // const handleCountryChange = (e) => {
  //   setCountry(e.target.value);
  // }

  const handlePhoneChange = (inputPhone, countryData) => {
    setPhone(inputPhone);
    setCountryCode(countryData.dialCode);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleEnquiryChange = (e) => {
    setEnquiry(e.target.value);
  };

  const handleTypeOfContentChange = (typeOfContent) => {
    //console.log(`Selected value: ${selectedOption.value}`);
    // setTypeOfContent(selectedOption.value);
    setTypeOfContent(typeOfContent);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // if(selCountryExpectedLength - countryCode.length - 1 !== phone.length){ //getNumberLength
    //   alert('Please enter correct phone ')
    // }

    const contactDetails = {
      firstName: firstName,
      lastName: lastName,
      organizationName: organizationName,
      country: countryName ? countryName.label : "",
      phone: phone,
      email: email,
      enquiry: enquiry,
      countryCode: countryCode,
      designation: designation,
      typeOfContent: typeOfContent ? typeOfContent.label : "",
    };

    if (phone.length - countryCode.length === 0) {
      // alert('Please fill phone number');
      setPhoneFailure(true);
      return;
    }
    // verify recaptcha -->
    const captchaToken = recaptchaRef.current.getValue();
    recaptchaRef.current.reset();
    if (!captchaToken) {
      console.log("captcha is not filled ");
      setShow(true);
      setMessage("Please! verify reCaptcha");
      setLoader(false);
      return;
    }

    const slug = await generateTokenHandler();
    console.log("captcha-----", captchaToken);
    // api call for google recaptcha
    axios
      .post(
        BASE_URL + "verifyCaptcha",
        {
          token: captchaToken,
        },
        {
          headers: {
            slug: slug,
          },
        }
      )
      .then((response) => {
        console.log(response?.data);
        if (response?.data?.status) {
          if (response?.data?.data?.success) {
            console.log("recaptcha-verified", response.data);
          } else {
            setShow(true);
            setMessage("Please! verify reCaptcha");
            return;
          }
        }
        if (!response?.data?.status) {
          setShow(true);
          setMessage("Something went wrong");
          return;
        }
      })
      .catch((error) => {
        console.log(error);
        setShow(true);
        setMessage("Please! verify reCaptcha");
        return;
      });
    console.log(contactDetails);
    const jsonObj = JSON.stringify(contactDetails);

    saveContactUsDetails(jsonObj)
      .then((response) => {
        if (response.data.status) {
          setSuccess(true);
          setTimeout(() => {
            setSuccess(false);
          }, 5000);
        } else {
          setFailure(true);
          setTimeout(() => {
            setFailure(false);
          }, 5000);
        }
      })
      .catch((err) => {
        setFailure(true);
        setTimeout(() => {
          setFailure(false);
        }, 5000);
      });

    setPhoneFailure(false);
    setFirstName("");
    setLastName("");
    setOrganizationName("");
    // setCountry("");
    setCountryName("");
    setPhone("91");
    setEmail("");
    setEnquiry("");
    setDesignation("");
    setTypeOfContent(null);
    setLoader(false);
    setMessage("");
  };

  // const handleFormSubmit = (e) => {
  //   e.preventDefault();

  // };

  return (
    <div>
      <div className="container mt-3 ">
        <div className="containe-body">
          <div className="w-75 m-auto contactUsForm">
            <div className="card contact-us-card">
              <div className="card-header fs-3 text-center">
                <div className="contact-us-title">Contact Us</div>
                <div className="contact-email">
                  <EmailIcon /> sales@boxofic.com
                </div>
              </div>
              <div className="card-body">
                <form
                  className="contact-form"
                  onSubmit={(e) => handleFormSubmit(e)}
                >
                  <div className="from-row">
                    <div className="mb-3">
                      <label>
                        First Name <span style={{ color: "black" }}> *</span>
                      </label>
                      <input
                        type="text"
                        name="firstName"
                        className="form-control my-input"
                        placeholder="First Name"
                        required
                        maxLength="50"
                        onChange={(e) => handleFirstNameChange(e)}
                        value={firstName}
                      ></input>
                    </div>
                    <div className="mb-3">
                      <label>
                        Last Name<span style={{ color: "black" }}> *</span>
                      </label>
                      <input
                        type="text"
                        name="lastName"
                        className="form-control my-input"
                        placeholder="Last Name"
                        required
                        maxLength="50"
                        onChange={(e) => handleLastNameChange(e)}
                        value={lastName}
                      ></input>
                    </div>
                  </div>
                  <div className="from-row">
                    <div className="mb-3">
                      <label>
                        Organization <span style={{ color: "black" }}> *</span>
                      </label>
                      <input
                        type="text"
                        name="organizationName"
                        className="form-control my-input"
                        placeholder="Organization Name"
                        required
                        maxLength="100"
                        onChange={(e) => handleOrganizationChange(e)}
                        value={organizationName}
                      ></input>
                    </div>
                    <div className="mb-3">
                      <label>Designation</label>
                      <input
                        type="text"
                        name="organizationName"
                        className="form-control my-input"
                        placeholder="Designation"
                        maxLength="100"
                        onChange={(e) => handleDesignationChange(e)}
                        value={designation}
                      ></input>
                    </div>
                  </div>
                  <div className="from-row">
                    <div className="mb-3">
                      <label>
                        Country <span style={{ color: "black" }}> *</span>
                      </label>
                      {/* <input type='text' name='country' className='form-control my-input' placeholder='Country' required maxLength="50"
                        onChange={(e) => handleCountryChange(e)} value={country}></input> */}
                      <Select
                        options={countryOptions}
                        value={countryName}
                        onChange={changeHandlerCountry}
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <label>
                        Type Of Content{" "}
                        <span style={{ color: "black" }}> *</span>
                      </label>

                      <Select
                        //placeholder="Type of Content"
                        value={typeOfContent}
                        onChange={handleTypeOfContentChange}
                        required
                        options={options}
                      />
                    </div>
                  </div>
                  <div className="from-row">
                    <div className="mb-3" style={{ color: "black" }}>
                      <label style={{ color: "white" }}>
                        Phone <span style={{ color: "black" }}> *</span>
                      </label>
                      <PhoneInput
                        country={"in"}
                        //placeholder='+91 1234567890'

                        value={phone}
                        onChange={(e, code) => handlePhoneChange(e, code)}
                      />
                      {phoneFailure && (
                        <span style={{ color: "tomato", position: "absolute" }}>
                          *Please enter phone number
                        </span>
                      )}
                    </div>
                    <div className="mb-3">
                      <label>
                        Email <span style={{ color: "black" }}> *</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        className="form-control my-input"
                        placeholder="Email"
                        required
                        onChange={(e) => handleEmailChange(e)}
                        value={email}
                      ></input>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label>
                      Enquiry <span style={{ color: "black" }}> *</span>{" "}
                    </label>
                    <textarea
                      name="enquiry"
                      className="form-control contact-textarea "
                      maxLength="500"
                      placeholder="Message"
                      required
                      onChange={(e) => handleEnquiryChange(e)}
                      value={enquiry}
                    ></textarea>
                  </div>
                  <div className="recaptcha-box">
                    <ReCAPTCHA
                      style={{
                        justifyContent: "center",
                        margin: "auto",
                        display: "flex",
                        marginBottom: "10px",
                      }}
                      ref={recaptchaRef}
                      sitekey={recaptcha_site_key}
                    />
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <button className="btn btn-light col-md-4">Submit</button>
                  </div>
                </form>
                {success && (
                  <p
                    className="success-failue-msg"
                    style={{ color: "green", textAlign: "center" }}
                  >
                    Details Submitted successfully.{" "}
                  </p>
                )}
                {failure && (
                  <p
                    className="success-failue-msg"
                    style={{ color: "red", textAlign: "center" }}
                  >
                    Form submission failed. Please try again.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={show}
          onClose={handleClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Fade in={show}>
            <Box sx={style} pt={2}>
              <Typography
                id="transition-modal-title"
                textAlign={"center"}
                mb={1}
              >
                {message}
              </Typography>
              <Button
                onClick={handleClose}
                variant="contained"
                style={{ margin: "auto" }}
              >
                OK
              </Button>
            </Box>
          </Fade>
        </Modal>
      </div>
    </div>
  );
};

export default ContactUs;
